import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProfileModel} from '../../../shared/models/profile.model';
import {ProfileService} from '../../services/profile.service';
import {LoadingService} from '../../../shared/service/loading.service';
import {Messages} from '../../../shared/messages/messages';
import {DialogService} from '../../../shared/service/dialog.service';
import { finalize } from 'rxjs/operators';
import {UpdateProfileComponent} from '../update-profile/update-profile.component';
import { MatDialog } from '@angular/material/dialog';
import {ErrorService} from '../../../shared/service/error.service';
import {HttpErrorResponse} from '@angular/common/http';
import {AdminRolesEnum} from '../../../shared/enums/admin-roles.enum';
import {AuthService} from '../../../shared/service/auth.service';
import { FdSelectConfig } from '../../../shared/fd-form-components/fd-select/fd-select.component';

const sortByDescription = (a: any, b: any) =>
  String(a?.description ?? '').localeCompare(String(b?.description ?? ''));

@Component({
    selector: 'app-list-profiles',
    templateUrl: './list-profiles.component.html',
    styleUrls: ['./list-profiles.component.scss'],
    standalone: false
})
export class ListProfilesComponent implements OnInit {

  displayedColumns =
    ['description', 'permissions', 'options_edit'];

  @Input() profiles: ProfileModel[];
  @Input() institutionNumber: string;
  @Input() serviceContract: string;

  constructor(private profileService: ProfileService,
              private loadingService: LoadingService,
              private dialogService: DialogService,
              private dialog: MatDialog,
              private errorService: ErrorService,
              private authService: AuthService) {
  }

  get hasWriteAccess() {
    return this.authService.isUserInRoles([AdminRolesEnum.PROFILE_WRITE]);
  }

  edit(profile: ProfileModel) {
    const dialogRef = this.dialog.open(UpdateProfileComponent, {
      width: '40%',
      height: '85%',
      disableClose: false,
      data: {
          profile,
        }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadingService.show();
      this.getAllProfilesInstitutionServiceContract();
    });
  }

  delete(profile: ProfileModel) {
    this.dialogService.openConfirmDialog(Messages.CONFIRM_DELETE_ACTION, () => {
      this.loadingService.show();
      this.profileService.deleteProfile(profile.id).subscribe(
        () => this.getAllProfilesInstitutionServiceContract(),
        (err: HttpErrorResponse) => this.errorService.handleXHRError(err, Messages.SEARCH_ERROR));
    });
  }

  getAllProfilesInstitutionServiceContract() {
    this.profileService.getProfilesByInstitutionAndServiceContract(this.institutionNumber, this.serviceContract)
    .pipe(finalize(() => this.loadingService.hide()))
    .subscribe(p => {
      this.profiles = p;
      this.orderProfile(this.profiles);
    });
  }

  ngOnInit(): void {
  }

  orderProfile(profiles: ProfileModel[])
  {
    for(let prof of profiles)
    {
      prof.roles.sort(sortByDescription);
    }
  }

  getRolesSummary(element: any): string {
    if (!element.roles || !Array.isArray(element.roles)) return '';
    return element.roles.slice(0, 2).map((r: any) => r.description).join(', ');
  }

}
